package components

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun CategoryFilter(
    selectedCategory: String?,
    onCategorySelected: (String?) -> Unit
) {
    val categories = listOf(
        null to "すべて",
        "Trade" to "Trade",
        "Signing" to "Signing",
        "Other" to "Other"
    )

    Div(attrs = {
        classes("category-filter")
    }) {
        categories.forEach { (value, label) ->
            Button(attrs = {
                classes("category-pill")
                if (selectedCategory == value) {
                    classes("category-pill-active")
                }
                onClick { onCategorySelected(value) }
            }) {
                Text(label)
            }
        }
    }
}

object CategoryFilterStyles : StyleSheet() {
    init {
        ".category-filter" style {
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            gap(0.5.em)
            padding(0.375.em)
            backgroundColor(Color("#1e293b"))
            borderRadius(16.px)
            property("width", "fit-content")
        }

        ".category-pill" style {
            property("border", "none")
            borderRadius(12.px)
            padding(0.6.em, 1.5.em)
            fontSize(0.95.em)
            fontWeight(500)
            cursor("pointer")
            property("transition", "all 0.2s ease")
            backgroundColor(Color("transparent"))
            color(Color("#f1f5f9"))
            opacity(0.5)
            fontFamily("inherit")
        }

        ".category-pill:hover" style {
            opacity(0.8)
            backgroundColor(rgba(255, 255, 255, 0.05))
        }

        ".category-pill-active" style {
            property("background", "linear-gradient(135deg, #3b82f6, #8b5cf6)")
            color(Color.white)
            fontWeight(600)
            opacity(1)
        }

        ".category-pill-active:hover" style {
            opacity(1)
        }

        media("(max-width: 600px)") {
            ".category-filter" style {
                flexWrap(FlexWrap.Wrap)
            }

            ".category-pill" style {
                padding(0.5.em, 1.em)
                fontSize(0.85.em)
            }
        }
    }
}